/* eslint-disable @typescript-eslint/no-magic-numbers, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/strict-boolean-expressions */
AOW.Dropship = {};
AOW.Dropship.init = function() {
	if($('#etsy-page').length > 0 || 
		$('#shopify-page').length > 0 || 
		$('#bigcartel-page').length > 0 || 
		$('#squarespace-page').length > 0) {
		const playPackagingVideo = function(video, iconReplay) {
			if(!video) {
				return;
			}

			const playPromise = video.play();

			if(playPromise && typeof playPromise.catch === 'function') {
				playPromise.catch(function() {
					iconReplay.removeClass('hide');
				});
			}
		};

		$('#packaging').find('.tabs').tabs();

		$.each($('.packaging-video'), function(){
			const video = $(this).find('video');
			const iconReplay = $(this).find('.material-icons');

			video.on('pause', function(){
				iconReplay.removeClass('hide');
			});

			iconReplay.on('click', function(){
				iconReplay.addClass('hide');
				playPackagingVideo(video[0], iconReplay);
			});
		});

		$('.packaging-tab').on('click', function(){
			const vidContainer = $(this).attr('data-id');
			const iconReplay = $('#'+vidContainer).find('.material-icons');
			iconReplay.addClass('hide');

			const vidToPlay = $('#'+vidContainer).find('video');
			playPackagingVideo(vidToPlay[0], iconReplay);
		});
	}

	if($('.drop-ship-page').length > 0){
		const integrationStores = $('.integration-store');
		const maxStep = integrationStores.length;

		if(maxStep === 0) {
			return;
		}

		integrationStores.first().addClass('active');

		$('.arrow').on('click', function(){
			const arrow = $(this);
			const activeStore = $('.integration-store.active');
			let step = parseInt(activeStore.attr('data-step'), 10);

			if(arrow.hasClass('prev')) {
				if(step === 1){
					step = maxStep;
				} else {
					step--;
				}
				activeStore.removeClass('active');
				$('.integration-store[data-step="'+step+'"]').addClass('active');
			} else {
				if(step === maxStep){
					step = 1;
				} else {
					step++;
				}
				activeStore.removeClass('active');
				$('.integration-store[data-step="'+step+'"]').addClass('active');
			}
			const storeHeight = $('.integration-store.active').outerHeight();
			$('#comparison-list').css('height',storeHeight + 10 + 'px');
		});

		$(window).on('resize.dropship', function() {
			const storeHeight = $('.integration-store.active').outerHeight();
			$('#comparison-list').css('height',storeHeight + 10 + 'px');
		});
		$(window).trigger('resize.dropship');
	}
};
